(function() {
    var descContainer = document.querySelector('.product-desc-foldout');
    if (!descContainer) return;

    // Use H2 if present, fall back to H3
    var headings = Array.from(descContainer.querySelectorAll('h2'));
    if (headings.length === 0) {
        headings = Array.from(descContainer.querySelectorAll('h3'));
    }

    headings.forEach(function(h, i) {
        var nextH = headings[i + 1] || null;

        // Collect all direct siblings between this heading and the next
        var contentNodes = [];
        var sibling = h.nextElementSibling;
        while (sibling && sibling !== nextH) {
            contentNodes.push(sibling);
            sibling = sibling.nextElementSibling;
        }

        // Build accordion item — insert BEFORE moving h out of DOM
        var itemDiv = document.createElement('div');
        itemDiv.className = 'desc-accordion-item';
        h.parentNode.insertBefore(itemDiv, h);

        h.classList.add('desc-accordion-trigger');
        h.setAttribute('aria-expanded', 'false');

        var contentDiv = document.createElement('div');
        contentDiv.className = 'desc-accordion-content';
        contentNodes.forEach(function(el) { contentDiv.appendChild(el); });

        h.addEventListener('click', function() {
            var isOpen = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', String(!isOpen));
            contentDiv.classList.toggle('desc-accordion-open', !isOpen);
        });

        itemDiv.appendChild(h);
        itemDiv.appendChild(contentDiv);
    });
})();
